import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, UiToggle, BgLoader, TableZero, UiButton, OverlayLoader } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";
import { Table } from 'antd';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
const Listing = NiceModal.create(
  ({ id }) => {
    const [state, setState] = useState({ count: 0 });
    const modal = useModal();



    const fetchData = () => {
      instance
        .get("/get_listing?id=" + id)
        .then(function (response) {
          setState(response.data)


        })
        .catch(function (error) { })
        .then(function () { });
    }





    useEffect(() => {

      fetchData();


    }, []);



    const handleHide = () => {
      modal.hide();
    }




    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title></BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={state.loader} />
        <BootstrapModal.Body>
          {state.status ?
            <div>

              {state.images.length ? <>
                <Carousel>
                  {state.images.map((img, i) => (
                    <div key={i} className="imgwrap">
                      <img src={img.url} alt="" />
                    </div>
                  ))}

                </Carousel>
              </> : null}
              <h2 className="fw-bold fs-5">{state.item.name}</h2>
              <div className="pt-2 border-top pb-2 mt-2">
                <h6>Contact Details:</h6>
                <div className="d-flex justify-content-between mb-2 pb-2 border-bottom align-items-center">

                  <b>{state.item.name1}</b> {state.item.mobile && <div><button className="btn btn-sm btn-primary me-2" onClick={() => window.open("tel:" + state.item.mobile)}>Call</button><button className="btn btn-sm btn-success me-2" onClick={() => window.open("https://wa.me/" + state.item.mobile)}>WhatsApp</button></div>}
                </div>
                <div className="d-flex justify-content-between align-items-center">

                  <b>{state.item.name2}</b> {state.item.mobile2 && <div><button className="btn btn-sm btn-primary me-2" onClick={() => window.open("tel:" + state.item.mobile2)}>Call</button><button className="btn btn-sm btn-success me-2" onClick={() => window.open("https://wa.me/" + state.item.mobile2)}>WhatsApp</button></div>}
                </div>
                
              </div>
              {state.item.specialist && <div><b>Specialist:</b> {state.item.specialist}</div> }
              <div className="pt-2 border-top pb-2 mt-2">
              {state.item.gst_number && <div><b>GST Number:</b> {state.item.gst_number} {state.item.ownership_type}</div>}
              {state.item.iec_number && <div><b>IEC Number:</b> {state.item.iec_number}</div>}
              {state.item.establishment_year && <div><b>Establishment Year:</b> {state.item.establishment_year}</div>}
              {state.item.monthly_production_capacity && <div><b>Monthly Production Capacity:</b> {state.item.monthly_production_capacity}</div>}
              {state.item.email && <div><b>Email:</b> {state.item.email}</div>}
              {state.item.website && <div><b>Website:</b> {state.item.website} <button className="btn btn-sm btn-success me-2" onClick={() => window.open(state.item.website)}>Visit</button></div>}
              </div>
              <div className="pt-2 border-top pb-2 mt-2">
                <div className="d-flex justify-content-between align-items-center">
                  <h6>Address:</h6>
                  {state.item.google_map_link && <button className="btn btn-sm btn-success me-2" onClick={() => window.open(state.item.google_map_link)}>Direction</button>}
                  </div>
                <p>{state.item.address}</p>
              </div>
            

            </div>
            : <BgLoader />}
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default Listing;
